import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';

const LANGUAGE_STORAGE_KEY = 'goexcurs_language';

// Detect language from browser locale
const detectLanguage = (): string => {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved) return saved;
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang && ['en', 'de', 'ru', 'tr'].includes(browserLang)) {
    return browserLang;
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    ru: { translation: ru },
    tr: { translation: tr },
  },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Listen for language changes and persist to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
});

export default i18n;
